import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  STATUS_CONFLICT,
  STATUS_FORBIDDEN
} from "../../../core/constants/const";
import { LOGOUT_TIMEOUT } from "../../../core/constants/consts";
import { ReservationWs } from "../../../core/models/reservation.ws";
import { RoomListWs } from "../../../core/models/room.list.ws";
import { RoomWs } from "../../../core/models/room.ws";
import { DateStringPipe } from "../../../shared/pipes/date.string.pipe";
import { MessagesPipe } from "../../../shared/pipes/messages.pipe";
import { AuthenticationService } from "../../../shared/services/authentication.service";
import { BaseService } from "../../../shared/services/base.service";
import { FlashMessagesService } from "../../../shared/services/flash-messages.service";
import { ReservationService } from "../../../shared/services/reservation.service";
import { Utils } from "../../../shared/utils/utils";

@Component({
  selector: "roomWithouTime",
  templateUrl: "room.without.time.html",
  styleUrls: ["room-withoutime.scss"]
})
export class RoomWithoutTime implements OnInit {
  room: RoomWs;
  date: Date;
  modalReservation: ReservationWs;
  showModal: boolean;
  showServerLunchMsg: boolean;
  reservationResponse: string;

  constructor(
    private router: Router,
    private utils: Utils,
    private reservationService: ReservationService,
    private authenticationService: AuthenticationService,
    private flashMessagesService: FlashMessagesService,
    private baseService: BaseService
  ) {}

  ngOnInit() {
    if (
      !this.authenticationService.getPermissionsForCurrentUser()
        .allowReservation
    ) {
      this.router.navigate(["/menu/home"]);
    }

    this.room = new RoomWs("", "", "", "", "");
    this.showModal = false;

    if (localStorage.getItem("reservationFilterNoTime")) {
      let reservation = JSON.parse(
        localStorage.getItem("reservationFilterNoTime")
      ) as ReservationWs;
      let actualDate = new Date();

      if (
        reservation.dateFromInMillis &&
        this.utils.compareDatesWithoutTime(
          reservation.dateFromInMillis,
          actualDate
        ) >= 0 &&
        reservation.room
      ) {
        this.date = new Date(reservation.dateFromInMillis);
        this.room = reservation.room;
      } else {
        localStorage.removeItem("reservationFilterNoTime");
        this.router.navigate(["/menu/reservations"]);
      }
    } else {
      this.router.navigate(["/menu/reservations"]);
    }
  }

  showModalReservation($event) {
    this.modalReservation = $event;
    this.showModal = true;
  }

  saveReservation($event) {
    this.reserveRoom($event);
  }

  closeDialog() {
    this.modalReservation = null;
    this.showModal = false;
  }

  reserveRoom(reservation: ReservationWs) {
    let roomList = new RoomListWs(
      reservation.dateFrom,
      reservation.dateTo,
      reservation.reason,
      parseInt(reservation.room.capacityMax)
    );
    let messagesPipe = new MessagesPipe();
    let successMessage = "";
    this.reservationService
      .reservationBooking(
        reservation.room,
        roomList,
        this.authenticationService.getToken()
      )
      .subscribe(
        response => {
          let dateStringPipe = new DateStringPipe();
          localStorage.removeItem("reservationFilterNoTime");

          if (response.message != null && response.message.length > 0) {
            this.showServerLunchMsg = true;
            this.reservationResponse = response.message;
            this.closeDialog();
          } else {
            successMessage = messagesPipe.transform("room_reserved_msg", [
              reservation.room.name,
              dateStringPipe.transform(roomList.dateFrom.toString(), "DD/MM"),
              dateStringPipe.transform(roomList.dateFrom.toString(), "HH:mm"),
              dateStringPipe.transform(roomList.dateTo.toString(), "HH:mm")
            ]);

            this.flashMessagesService.grayOut(false);
            this.flashMessagesService.show(successMessage, {
              cssClass: "alert-success",
              timeout: 3000
            });

            this.router.navigate(["/menu/reservations"]);
          }
        },
        error => {
          if (error.code == STATUS_FORBIDDEN) {
            this.authenticationService.refreshToken().subscribe(
              response => {
                this.reserveRoom(reservation);
              },
              error => {
                this.authenticationService.validateSessionId().subscribe(
                  response => {
                    this.reserveRoom(reservation);
                  },
                  error => {
                    this.flashMessagesService.grayOut(false);
                    this.flashMessagesService.show(
                      messagesPipe.transform("error_forbidden"),
                      { cssClass: "alert-danger", timeout: 3000 }
                    );

                    setTimeout(() => {
                      this.authenticationService.logout();
                    }, LOGOUT_TIMEOUT);
                  }
                );
              }
            );
          } else {
            this.baseService.showErrorDialog(
              this.flashMessagesService,
              error,
              messagesPipe.transform("reserve_creation_error")
            );

            if (error.code == STATUS_CONFLICT) {
              localStorage.removeItem("reservationFilterNoTime");
              this.router.navigate(["/menu/reservations"]);
            } else {
              this.router.navigate(["/menu/home"]);
            }
          }
        }
      );
  }

  backToReservationList(): void {
    this.router.navigate(["/menu/reservations"]);
  }
}
